import React from "react";
import Team from "./Team";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Icon from "./Icon";

export default function Profile() {
  return (
    <div>
      <Navbar />
      <Team />
      <Icon />
      <Footer />
    </div>
  );
}
